<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div class="h-fit relative">
      <div class="w-full">
        <div class="mt-0">
          <div class="md:mt-5 relative min-h-[400px] flex flex-col lg:flex-row w-full">
            <h1 class="text-[27px] md:hidden">{{ testData.data.title }}</h1>
            <div
              class="w-full bg-[#F0FBFB] lg:absolute top-0 left-0 h-[200px] md:h-[400px] lg:h-[calc(100%-7rem)] z-10"
            >
              <div
                class="tests-image w-full h-full lg:max-h-none lg:w-[55%] h-full bg-cover"
                alt=""
                :style="{
                  backgroundImage: 'url(' + JSON.stringify(testData.data.hero_banner.permalink) + ')',
                }"
              />
            </div>
            <div class="flex justify-end w-full -mt-12 lg:mt-0 z-20">
              <div class="lg:w-1/2 mx-4 lg:mt-14 md:py-16 p-8 pt-5 md:px-10 bg-white rounded-lg shadow-lg">
                <div class="space-y-6 md:space-y-9 flex flex-col lg:w-5/6">
                  <h1 class="lg:text-4xl text-[27px] font-semibold text-start md:block hidden lg:ml-7">
                    {{ testData.data.title }}
                  </h1>
                  <span class="font-bold text-start text-[18px] lg:ml-7 sm:ml-0">
                    {{ testData.data.intro_text }}
                  </span>
                  <div class="leading-7 text-dark-blue lg:ml-7" v-html="testData.data.body_text"></div>
                  <NuxtLinkLocale
                    :locale="switchBlogLocale()"
                    @click="openServiceModal()"
                    class="underline cursor-pointer text-secondary lg:ml-7"
                  >
                    {{ $t("tests.cardLink") }}
                  </NuxtLinkLocale>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- How It Works Modal  -->
      <ProductInfoServiceModal :is-open="openModal" @on-modal-close="closeServiceModal" />

      <!-- FILTER SIDE BAR  -->
      <div v-if="filterSideBarOpen">
        <ProductMobileFilterSideBar
          :is-visible="filterSideBarOpen"
          :filters="contentFilters"
          @on-side-bar-close="closeFilterSideBar"
          :results-number="filtredProducts.length"
        />
      </div>
      <NuxtLayout name="center" class="flex my-14 lg:mt-16">
        <!-- <ProductAsideFilters v-if="!filterSideBarOpen">
         
        </ProductAsideFilters> -->
        <!-- FILTER OPTIONS  -->
        <NuxtLayout name="side-filters">
          <ProductFilterSidebar
            v-if="!filterSideBarOpen"
            isActive
            :contentFilters="contentFilters"
          ></ProductFilterSidebar>
        </NuxtLayout>
        <div class="w-full lg:ml-10 bg-white">
          <div class="flex flex-col md:flex-row justify-between md:items-center">
            <ClientOnly>
              <span>{{ $t("tests.showing") }} {{ filtredProducts.length }} {{ $t("common.results") }}</span>
            </ClientOnly>
            <div class="flex items-center space-x-4">
              <FilterFloatButton
                @clicked="openFilterSideBar()"
                v-if="isVisible && !isCtaBlockVisible"
                :selectedFilters="selectedFilters"
              ></FilterFloatButton>
              <div class="relative">
                <BaseVSearchTextInput
                  id="search-product"
                  name="search-product"
                  :label="`${$t('filter.searchText')}`"
                  v-model="productSearch"
                />
                <button
                  class="flex justify-center items-center bg-secondary text-white md:w-8 md:h-8 w-[40px] h-[40px] rounded-md absolute right-1 top-5 md:top-1 z-10"
                  @click="onClick"
                >
                  <SearchIcon class="w-6 h-6" />
                </button>
              </div>
              <div class="relative hidden lg:flex">
                <BaseSelect :options="sortOptions" :value="sortOptionSelected" class="w-52" @onClick="setSortOption" />
              </div>
            </div>
          </div>

          <div ref="target" class="-mx-4">
            <ProductList></ProductList>
          </div>
        </div>
      </NuxtLayout>
      <CTABlock imgSrc="USPs_graphic_03_1" get-started ref="ctaBlock" />
    </div>
  </div>
</template>
<script setup>
import { useProductStore } from "@/stores/filter";
import { SearchIcon } from "@heroicons/vue/outline";
import CTABlock from "~~/components/clinic/CTABlock.vue";

const route = useRoute();
const filterStore = useProductStore();

const contentFilters = ref([]);
const filterSideBarOpen = ref(false);

const productSearch = computed({
  get() {
    if (filterStore.search == "") {
      filterStore.setSortOption(2);
    } else {
      filterStore.setSortOption(0);
    }
    return filterStore.search;
  },
  set(val) {
    filterStore.setSearchValue(val);
  },
});
const target = ref(null);
const ctaBlock = ref(null);
const { isCtaBlockVisible, isVisible } = useCheckVisibility(target, ctaBlock);

const { data: testData } = await useTestDetail();
contentFilters.value = await useFilterOptions();
filterStore.getFilterOptions(contentFilters.value.min_price, contentFilters.value.max_price);

onMounted(() => {
  filterStore.setSortOption(2);
  if (route.query.condition) {
    let selectedCondition = route.query.condition;
    filterStore.setChecked(selectedCondition);
    const filteredValue = contentFilters.value.infections.find((data) => data.slug == route.query.condition);
    filterStore.setCollection(filteredValue, "infection");
  }
});

const selectedFilters = computed({
  get() {
    return filterStore.getCheckedFilter;
  },
});

const sortOptions = computed(() => filterStore.getSortOptions);
const sortOptionSelected = computed(() => filterStore.selectedSortOption);
const filtredProducts = computed(() => filterStore.filtredTests);

const setSortOption = (item) => {
  filterStore.setSortOptionMobile(item);
};

const openFilterSideBar = () => {
  document.body.classList.toggle("overflow-hidden");
  filterSideBarOpen.value = true;
};
const closeFilterSideBar = () => {
  document.body.classList.toggle("overflow-hidden");
  filterSideBarOpen.value = false;
};

const openModal = ref(false);

const openServiceModal = () => {
  openModal.value = true;
};
const closeServiceModal = () => {
  openModal.value = false;
};

useMetaTitles(testData.value.data, "tests");

const breadcrumbs = getBreadcrumbs("tests");
</script>
